module.exports = __webpack_public_path__ + "static/media/bbva.f8a74989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/quote-step/bbva.png
// module id = 1671
// module chunks = 0